import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';

import { BreadcrumbsDropdown } from '../index';
import { LiveScoreboard } from '../../components/common';

const LiveScoreboardWithBreadcrumbs = ({
    store: {
        betting: { setNavigationDropdown },
    },
    store,
    viewSize,
    matchInstance,
    language,
    type,
    isStatsShown,
    setStatsShown,
    isBetradarWidgetError,
}) => {
    const [matchesDropdownShown, setMatchesDropdownShown] = useState(false);
    const [trigger, setTrigger] = useState(false);

    useEffect(() => {
        setTimeout(() => setNavigationDropdown(matchesDropdownShown), 200);
    }, [matchesDropdownShown]);

    return (
        <LiveScoreboard
            match={matchInstance}
            type={type}
            viewSize={viewSize}
            language={language}
            matchesDropdownShown={matchesDropdownShown}
            isStatsShown={isStatsShown}
            setStatsShown={setStatsShown}
            isBetradarWidgetError={isBetradarWidgetError}
            setTrigger={setTrigger}
            isLogged={store.user.isLogged}
            favorites={store.betting.favorites}
        >
            <BreadcrumbsDropdown
                type={type}
                matchesDropdownShown={matchesDropdownShown}
                setMatchesDropdownShown={setMatchesDropdownShown}
                routerMatch={matchInstance}
                trigger={trigger}
                setTrigger={setTrigger}
            />
        </LiveScoreboard>
    );
};

export default inject('store')(observer(LiveScoreboardWithBreadcrumbs));
